<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" :title="dialogTitle">
      <div class="default-table">
        <el-table :data="dataList" class="w-full" border>
          <el-table-column label="执行环节" prop="step_title" align="center">
            <template slot-scope="scope">
              <span :title="scope.row.step">{{ scope.row.step_title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否完成" prop="is_done" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.is_done === 'Y' "><i class="el-icon-check" style="font-size: 18px;color: #67C23A"></i></span>
              <span v-else>&nbsp;</span>
            </template>
          </el-table-column>
          <el-table-column label="备注信息" prop="remark" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EditableCell from "@/components/EditableCell";
import { mapGetters } from "vuex";

export default {
  name: "ArtistScheduleRateProgress",
  components: {
    EditableCell
  },
  computed: {
    ...mapGetters(['userPermissions', 'userDptInfo']),
    dialogTitle() {
      return `执行进度：${ this.info.nickname }/${ this.info.product_title }`
    }
  },

  props: {
    editObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  // watch: {
  //   'editObj.id'(val, oldVal) {
  //     if (val !== oldVal)
  //       this.getAInfo()
  //   }
  // },
  data() {
    return {
      dataList: [
        // { step: '平台接单', is_done: 'N', remark: '' },
        // { step: 'brief', is_done: 'N', remark: '' },
        // { step: '收到样品', is_done: 'N', remark: '' },
        // { step: '脚本', is_done: 'N', remark: '' },
        // { step: '拍摄', is_done: 'N', remark: '' },
        // { step: '素材审核', is_done: 'N', remark: '' },
        // { step: '剪辑', is_done: 'N', remark: '' },
        // { step: '初稿审核', is_done: 'N', remark: '' },
        // { step: '封面', is_done: 'N', remark: '' },
        // { step: '文案', is_done: 'N', remark: '' },
        // { step: '定稿', is_done: 'N', remark: '' },
        // { step: '发布', is_done: 'N', remark: '' },
      ],
      canEdit: false,
      info :{}
    }
  },
  methods: {
    onOpen() {
      this.getAInfo()
    },
    onClose() {
      // this.$refs['elForm'].resetFields()
      this.$emit('refreshData')
    },
    close() {
      this.$emit('update:visible', false)
    },
    changeVal(row, field) {
      const postData = { plan_id: this.editObj.id, step: row.step }
      postData[field] = row[field]
      this.$api.saveBusinessPlanStep(postData)
    },
    saveCheck(row) {
      const postData = { plan_id: this.editObj.id, step: row.step, is_done: row.is_done }
      this.$api.saveBusinessPlanStep(postData)
    },
    async getAInfo() {
      const { list, info } = await this.$api.getBusinessPlanStep({ plan_id: this.editObj.id })
      // this.canEdit = this.calcPermission(artist_info.group_id)
      this.info = info
      this.$nextTick(() => {
        this.dataList = list
      })
    },
    //计算权限
    calcPermission(currentGroupId) {
      //录入权限
      const hasPermission = this.userPermissions.indexOf('business_manage_create') > -1
      //范围权限
      let rangePermission = false

      // let currentGroupId = this.searchCondition.group_id
      //数据范围
      //有全公司 数据权限
      if (this.userPermissions.indexOf('business_manage_data_company') > -1) {
        rangePermission = true

      } else if (this.userPermissions.indexOf('business_manage_data_dpt') > -1) {
        // 当前选中的组在本部及其组，则有权限修改
        const dptRange = this.userDptInfo.dpt_range
        rangePermission = dptRange ? dptRange.indexOf(currentGroupId) > -1 : false

      } else if (this.userPermissions.indexOf('business_manage_data_group') > -1) {
        // 当前选中的组在个人归属的组（一个人可在多组），则有权限修改
        const dpt_ids = this.userDptInfo.my_dpt_range ? this.userDptInfo.my_dpt_range : []
        rangePermission = dpt_ids ? dpt_ids.indexOf(currentGroupId) > -1 : false

      } else {
        rangePermission = false
      }

      // console.log(`组：${ currentGroupId }, hasPermission:${ hasPermission },rangePermission:${ rangePermission }`)
      return hasPermission && rangePermission
    },
  }
}
</script>

<style scoped>

</style>
